/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { TripPlan } from '../../../loco/shared/model/trip-plan.model';

/**
 * @export
 * @class LmsLocoTripPlanComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-trip-plan',
  templateUrl: './lms-loco-trip-plan.component.html',
  styleUrls: ['./lms-loco-trip-plan.component.scss']
})
export class LmsLocoTripPlanComponent implements OnInit, OnDestroy {

  @Input() tripPlan: TripPlan;
  @Input() locoLabel: any;

  /**
   * Creates an instance of LmsLocoTripPlanComponent.
   *
   * @memberOf LmsLocoTripPlanComponent
   */
  constructor(public appUtilityService: AppUtilityService) { }

  /**
   * @memberOf LmsLocoTripPlanComponent
   */
  ngOnInit() {
  }

  /**
   * @memberOf LmsLocoTripPlanComponent
   */
  ngOnDestroy() {
  }

  /**
   * Changes to add 0 to sequence number
   * @private
   * @param {any} str
   * @param {any} padString
   * @param {any} max
   * @returns {string}
   * @memberOf LmsLocoTripPlanComponent
   */
  leftPad(str, padString, max): string {
    if (!str || str === '') {
      return '-';
    } else {
      str = str.toString();
      return str.length < max ? this.leftPad(padString + str, padString, max) : str;
    }

  }
}
